import "../../../types/tawk";


export const tawkOpenChat = (visitor: {
  name: string;
  email: string;
  phone: string;
  message: string;
}) => {
  window.Tawk_API = window.Tawk_API || {};
  const Tawk_API = window.Tawk_API;

  const { message, ...attributes } = visitor;

  const initChat = () => {
    Tawk_API.setAttributes?.(attributes, (error: unknown) => {
      if (error) console.warn("Tawk setAttributes error:", error);
    });
    if (message) Tawk_API.sendMessage?.(message);
  };

  Tawk_API.maximize?.();

  if (Tawk_API.setAttributes) {
    initChat();
  } else {
    const prevOnLoad = Tawk_API.onLoad;
    Tawk_API.onLoad = () => {
      prevOnLoad?.();
      initChat();
    };
  }
};